import {observer} from 'mobx-react-lite'
import React from 'react'
import {
  rowHeight,
  useTimelineNewStore
} from '@components/timeline-new/timeline-new-store'
import {TwSwimlane} from './containers'

export interface BackgroundSwimlaneProps {
  ix: number
  path: string
  className?: string
}

export const BackgroundSwimlane = observer<BackgroundSwimlaneProps>(
  ({ix, path, className}) => {
    const [state] = useTimelineNewStore()
    const top = ix * rowHeight
    const hovered = state.hoveredRowPath === path

    return (
      <BackgroundSwimlaneBase
        path={path}
        top={top}
        hovered={hovered}
        className={className}
      />
    )
  }
)

const BackgroundSwimlaneBase = observer(
  ({
    path,
    top,
    hovered,
    className
  }: {
    path: string
    top: number
    hovered: boolean
    className?: string
  }) => {
    const [, store] = useTimelineNewStore()

    return (
      <TwSwimlane
        style={{transform: `translate(0px,${top}px)`}}
        className={className}
        $hovered={hovered}
        onMouseMove={() => store.setHoveredRow(path)}
        onMouseLeave={() => store.setHoveredRow(undefined)}
      />
    )
  }
)
